module.exports = [
  require('./tasha_s_hideous_laughter'),
  require('./thaumaturgy'),
  require('./thorn_whip'),
  require('./tongues'),
  require('./true_resurrection'),
  require('./true_polymorph'),
  require('./tsunami'),
]
